export default "__VITE_ASSET__d64aec08__"